import { Component, Inject } from '@angular/core';

import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RockModel } from '../../../core/models/rock-model.model';

@Component({
  selector: 'app-select-rock-model-popup',
  standalone: true,
  imports: [
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule
],
  templateUrl: './select-rock-model-popup.component.html',
  styleUrl: './select-rock-model-popup.component.scss',
})
export class SelectRockModelPopupComponent {
  displayedColumns: string[] = [
    'name',
    'totalPorosity',
    'permeability',
    'formationFactor',
    'select'
  ];
  rockModels: RockModel[];
  selectedRockModel: RockModel | null = null;

  constructor(
    public dialogRef: MatDialogRef<SelectRockModelPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { rockModels: RockModel[] },
  ) {
    this.rockModels = data.rockModels;
  }

  onRowClick(model: RockModel): void {
    this.selectedRockModel = this.selectedRockModel?.name === model.name ? null : model;
  }

  selectRockModel(): void {
    if (this.selectedRockModel) {
      this.dialogRef.close(this.selectedRockModel);
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
